// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard.notifications.details .dashboard__title{margin-top:0}.campaign-details{background:#f5f7f8}.card{margin-bottom:20px}.card .fa-icon{margin-right:8px;height:11px}", ""]);
// Exports
module.exports = exports;
